import { render, staticRenderFns } from "./MemberCenterAdminInviteNew.vue?vue&type=template&id=0d4c44e1&lang=pug&"
import script from "./MemberCenterAdminInviteNew.vue?vue&type=script&lang=js&"
export * from "./MemberCenterAdminInviteNew.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterAdminInviteNew.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports